import React from 'react'; 
import { Grid, Typography, Box, useTheme } from '@mui/material';

const brands = [
  { name: 'ProPharma', logo: '/2.png' },
  { name: 'Kyowa Kirin', logo: '/3.png' },
  { name: 'TRIO', logo: '/4.png' },
];

const BrandsThatTrustUs = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ py: 5, px: 2, textAlign: 'center' }}>
      <Typography variant="h4" fontWeight="bold" mb={4}>
        Brands That Trust Us
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {brands.map((brand, index) => (
          <Grid item xs={12} sm={4} md={3} key={index}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '200px',
                height: '200px',
                margin: '0 auto',
                borderRadius: 2,
                bgcolor: isDarkMode ? 'grey.800' : 'transparent', // Gray card in dark mode
                p: 2,
              }}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BrandsThatTrustUs;
